export default __webpack_public_path__ + "static/media/pattern.b155c8bf.png";